﻿import Floatl from "floatl";

class InputLabelItem {
    constructor(el, index) {
        this.render(el, index);
    }

    render(el, index) {
        new Floatl(el);
    }
}

class InputLabel {
    constructor(selector, element) {
        this.all = element.querySelectorAll(selector);
        for (var i = 0; i < this.all.length; i++) {
            this.render(this.all[i], i);
        }
    }

    render(el, index) {
        new InputLabelItem(el, index);
    }
}


export default InputLabel;